import agencyDashboardAPI from '@/utils/api/agencyDashboard';
import { genericError } from '@/utils/alerts.service';

export const findPartners = {
  namespaced: true,
  state: {
    partners: [],
    query: '',
    filters: '',
    count: 0,
    pageSize: 48,
    timeout: null,
    currentPage: 1,
  },
  getters: {
    getPartners(state) {
      const x = state.partners.filter(partner => {
        const query = state.query.toLowerCase();
        return partner.name.toLowerCase().includes(query);
      });
      x.sort((a, b) => {
        const first = a.name;
        const second = b.name;
        return first.localeCompare(second, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });
      return x;
    },
    query(state) {
      return state.query;
    },
  },
  mutations: {
    setPartners(state, results) {
      state.partners = results;
    },

    setCount(state, count) {
      state.count = count;
    },

    setCurrentPage(state, page) {
      state.currentPage = page;
    },

    setQuery(state, query) {
      state.query = query;
    },
  },
  actions: {
    resetQuery({ dispatch, commit }) {
      commit('setQuery', '');
      dispatch('fetchPartners', 1);
    },
    async fetchPartners({ dispatch, commit, state }, page = 1) {
      return agencyDashboardAPI
        .getPotentialPartners(page, state.pageSize, state.query)
        .then(data => {
          commit('setCount', data.count);
          commit('setPartners', data.results);
          return true;
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async addPartner({ dispatch }, id) {
      return agencyDashboardAPI
        .addPartner({ vendor: id })
        .then(() => {
          dispatch('fetchPartners', 1);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async removePartner({ dispatch }, id) {
      return agencyDashboardAPI
        .deletePartner(id)
        .then(() => {
          dispatch('fetchPartners', 1);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    updateQueryAndFilter({ commit, dispatch, state }, query) {
      commit('setQuery', query);

      commit('setCurrentPage', 1);
      clearTimeout(state.timeout);
      state.timeout = setTimeout(() => {
        dispatch('fetchPartners', 1);
      }, 500);
    },

    setCurrentPage({ commit }, page) {
      commit('setCurrentPage', page);
    },
  },
};
